<script>
export default {
  props: {
    title: { type: String, required: true },
    value: { type: [String, Number], default: '' },
    compact: { type: Boolean, default: false },
  },
};
</script>

<template>
  <div class="overflow-auto" :class="compact ? 'py-0 px-0' : 'py-3 px-4'">
    <div class="items-center flex justify-between mb-1.5">
      <!-- Papel "rotulo" da escala descrita em PanelSection.vue: mesmo
           tamanho do valor, em cinza legivel (#1243). -->
      <span class="text-xs text-muted">
        {{ title }}
      </span>
      <slot name="button" />
    </div>
    <div v-if="value" class="text-xs break-words">
      <slot>
        {{ value }}
      </slot>
    </div>
  </div>
</template>
